import React from 'react';

const CommunityConnect = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g fill="#5A5A5A">
          <g>
            <g>
              <path
                d="M14.917 14.5c.414 0 .75.336.75.75 0 .38-.282.694-.648.743l-.102.007H9.334c-2.605 0-4.714 1.915-4.829 4.295L4.5 20.5v.29l.226.05c.278.06.587.118.927.175l.35.057c1.725.267 3.77.428 6.122.428 1.65 0 3.165-.08 4.547-.225.412-.043.78.256.824.668.043.412-.256.781-.668.824-1.433.15-3 .233-4.703.233-2.43 0-4.552-.167-6.353-.446-.507-.079-.961-.162-1.36-.247l-.425-.096-.392-.1-.061-.018c-.282-.084-.485-.324-.526-.61L3 21.376V20.5c0-3.25 2.72-5.88 6.102-5.996l.232-.004h5.583zm4.833.75c.38 0 .693.282.743.648L20.5 16v1.25h1.25c.414 0 .75.336.75.75 0 .38-.282.694-.648.743l-.102.007H20.5V20c0 .414-.336.75-.75.75-.38 0-.693-.282-.743-.648L19 20v-1.25h-1.25c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743l.102-.007H19V16c0-.414.336-.75.75-.75zM12 1c2.908 0 5.25 2.534 5.25 5.637 0 3.258-2.43 6.613-5.25 6.613S6.75 9.895 6.75 6.637C6.75 3.534 9.092 1 12 1zm0 1.5c-2.08 0-3.785 1.844-3.785 4.137 0 2.51 1.886 5.113 3.785 5.113 1.9 0 3.785-2.603 3.785-5.113C15.785 4.344 14.08 2.5 12 2.5z"
                transform="translate(-762 -122) translate(154 84) translate(608 38)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CommunityConnect;
